import { Route } from '@angular/router';
import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { driverResolver } from './driver.resolver';

export const driverRoutes: Route[] = [
  {
    path: '',
    title: _('i18n.Driver.List.Title'),
    loadComponent: () =>
      import('./driver-list/driver-list.component').then(
        (m) => m.DriverListComponent,
      ),
  },
  {
    path: ':driverId',
    children: [
      {
        path: 'detail',
        resolve: { driver: driverResolver },
        loadComponent: () =>
          import('./driver-detail/driver-detail.component').then(
            (m) => m.DriverDetailComponent,
          ),
      },
      // TODO #44163: Guard https://dev.azure.com/techgroup/Maison%20du%20Software/_workitems/edit/44163/
      {
        path: 'edit',
        resolve: { driver: driverResolver },
        loadComponent: () =>
          import('./driver-edit/driver-edit.component').then(
            (m) => m.DriverEditComponent,
          ),
      },
    ],
  },
];
